import React, { useState, useEffect } from "react";
import styled from "styled-components";

const Input = styled.input`
    height: 30px;
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    position: relative;
    z-index: 2;
    float: left;
    width: 25%;
    margin: 0;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    display: table-cell;
`;

const Dropdown = styled.div`
    position: relative;
    white-space: nowrap;
    vertical-align: middle;
    display: table-cell;
`;

const Span = styled.span`
    position: relative;
    float: left;
    height: 30px;
`;

const SearchButton = styled.button`
    z-index: 2;
    margin-left: -1px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    height: 30px;
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px;
    box-shadow: none;
    border-width: 1px;
    position: relative;
    background-color: #00c0ef;
    border-color: #00acd6;
    border: 1px solid transparent;
    color: #fff;
`;

const Componeent = ({startDate, setStartDate, endDate, setEndDate, setRange, search}) => {
// const SearchText = ({keyword, search}) => {
    return (
        <>
            <Dropdown>
                <select style={{marginLeft:"10px"}} onChange={(e) => setRange(e.target.value)}>
                    <option key={"month"} value={"month"}>월간</option>
                    <option key={"week"} value={"week"}>주간</option>
                    <option key={"day"} value={"day"}>일간</option>
                </select>
            </Dropdown>
            <Input value={startDate} onChange={(event) => setStartDate(event.target.value)} />
            <Span>~</Span>
            <Input value={endDate} onChange={(event) => setEndDate(event.target.value)} />
            <Span>
                <SearchButton onClick={search}>search</SearchButton>
            </Span>
        </>
    )

};

const DateInput = (startDate, setStartDate, endDate, setEndDate, setRange, search) => {
    
    const [state, setState] = useState(startDate);
    const [state1, setState1] = useState(endDate);

    return [
        <Componeent startDate={state} endDate={state1} setStartDate={setStartDate} setEndDate={setEndDate} setRange={setRange} search={search}/>,
        setState,
        setState1
    ]

};

export default DateInput;